import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as dashboardActions from './../../actions/dashboardActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as commonActions from './../../actions/commonActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import * as authActions from '../../redux/modules/auth';
import LimitOrder from './LimitOrderComponent';
import FixOrder from './FixOrder';
import styles from './TradePanel.less';
import { ButtonToolbar, DropdownButton, MenuItem, Tabs, Tab } from 'react-bootstrap';
import config from './../../config';
import appConstants from './../../appConstants';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import i18next from 'i18next';
import HoverTable from './../../components/HoverTable/index.js';
import { TcoDropdown } from './../../components/UI/Dropdown/Dropdown';
import { applyStyle, applyClickActive,applyToHover, setDirection, getSeparator, unformatLang, getDefaultAcdAccount } from './../../utils/utils';
import '../../theme/styles/reactstrap.css';
import { bindActionCreators } from 'redux';
import track from 'react-tracking';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { displayInActiveAccMsg } from '../../utils/validation.js';

let cmdtyId;
let separator;
let decimal;
let wsData;

//apply langauge css
const directionData = [
  { "classNames": "widgettitle", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "vericalDotIcon", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "closeIcon", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "dropdown-menu", "elementType": "normal", "applyTo": "all", "tagNames": "ul" },
  { "classNames": "caret", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "cmdtyListWrap", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "resizeLayout", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "noRatesMsgDiv", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "cmdtyType", "elementType": "normal", "applyTo": "all", "tagNames": "p" },
  { "classNames": "col3", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "col4", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "trdMeasureDrpDown", "elementType": "normal", "applyTo": "all", "tagNames": "button" },
  { "classNames": "rightPart", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "valDate", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "nav-tabs", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "commentDiv", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "trdDropdownInput", "elementType": "normal", "applyTo": "all", "tagNames": "input" },
  { "classNames": "colAuto", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
];

@track((props, state) => ({ widgetDetails: { widget: "TradingPanel"}}))

class TradePanelComponent extends Component {
  constructor(props) {
    super(props);
    window.closeOrdConfirmMsg = this.closeOrdConfirmMsg.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  state = {
    selectedRmk: "",
    COM: null,
    cmdtyID: "",
    selectedCmdty: "",
    clickedRemove: false,
    selectedActualMktQty: 0,
    selectedQuantityMkt: "",
    selectedMeasureMkt: '',
    //ifClosed:true,
    quantityArrayMkt: [],
    key: 1,
    TCO: [],
    T1: '',
    DFMKT: [],
    MEASURE: [],
    showDialog: false,
    showtrdFlagModal: false,
    ordConfirmMsg: "",
    convFactor: [],
    qtyErrorMsg: "",
    qtyTypErrMsg: "",
    statusErrMsg: "",
    rateToolTip: true,
    showStock: '',
    convFact: '',
    CTID: [],
    isButtonDisabled: false,
    cmdtyIndex: 0,
    valueDate: "",
    buttonAskFlag: false,
    buttonBidFlag: false,
    showCnfrmMsg: false,
    Price: "",
    DealType: 'Buy',
    //Validty:'',
    //ValidtyKey:'',
    isSubmitDisabled: false,
    deleteWidget: [],
    LmtClicked: false,
    FixClicked: false,
    componentKey: 1,
    showGridOptions: false,
    selectedCssColorTheme: {},
    rateConvRoundOFFAsk: '',
    rateConvRoundOFFBid: '',
    mount: false,
    cmdtyLimit: false,
    trdProgressFlg: false,
    netIssueFlg: false,
    stkWiseAskMarkup: 0,
    stkWiseBidMarkup: 0,
    orderSocketClosed: false,
    showPrice: '',
    isCustInst: false,
    defaultAccountIsActive: false,
  }

  componentDidMount() {
    //Apply selected theme when component reloads
    this.setState({ mount: true });
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(ReactDOM.findDOMNode(this), this.props.selectedCssColorTheme, elementsData);

    const hoverElementsClassNames = [
      { "elmToHover": thisComponent.getElementsByClassName('closeBtn')[0], "classNames": "closeBtn" },
      { "elmToHover": thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames": "vericalDotIcon" }
      //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
    ];
    // //applyToHover(ReactDOM.findDOMNode(this), hoverElementsClassNames, allCssStyleRules);
    // applyClickActive(thisComponent.getElementsByTagName("li"), allCssStyleRules);
    setDirection(ReactDOM.findDOMNode(this), directionData, this.props.selectedLang);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
    try {
      if (this.props.selectedTabKey !== undefined) {
        this.setState({ key: this.props.selectedTabKey });
      }
      this.setState({ selectedCmdty: this.props.cmdtyPair });
      this.setState({ deleteWidget: this.props.deleteWidgetKey });
      localStorage.setItem('selectedTabKey', 1);
      this.props.setTradingstatus(localStorage.getItem('TRD_STATUS'));
      this.setState({ DealType: 'Buy' });
      this.setState({ OrderType: 1 });
      this.setState({ showStock: this.props.userDetail.showStock });
      let checkComodity;
      if (this.props.cmdtyPair) {
        checkComodity = this.props.cmdtyPair;
      } else {
        checkComodity = this.props.TCO[0].cmdtId;
      }
      this.setState({ selectedCmdty: checkComodity });
      const length = this.props.socketDataStatic.length;
      let index1;
      var cnt = 0;
      for (let index = 0; index < length; index++) {
        const cmdty = this.props.socketDataStatic[index].I;
        const cmdtyDes = this.props.socketDataStatic[index].ID;
        if (checkComodity === cmdty) {
          index1 = index;
          break;
        }
      }
      
      this.setState({ cmdtyIndex: index1 });
      this.setState({ COM: parseInt(this.props.socketDataStatic[index1].B) });
      this.setState({ isCustInst: parseInt(this.props.socketDataStatic[index1].C) !== 32 ? false : true });
      cmdtyId = this.props.socketDataStatic[index1].I;
      this.setState({ cmdtyID: this.props.socketDataStatic[index1].I });
      const T1 = this.props.socketDataStatic[index1].T1;
      this.setState({ T1: T1 });
      this.setState({ valueDate: this.props.socketDataStatic[index1].VD });
      const unit = [];
      var tmpConvFactor = new Map();
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        if (stk_type === T1) {
          unit.push(this.props.trdPanelData[index].C);
          tmpConvFactor.set(this.props.trdPanelData[index].C, this.props.trdPanelData[index].F);
        }
      }

      ///// conversion factor for custom instrument
      if (this.props.custInstStkData !== undefined) {
        for (let index = 0; index < this.props.custInstStkData.length; index++) {
          const stk_type = this.props.custInstStkData[index].S;
          if (stk_type === T1) {
            tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
          }
        }
      }
      parseInt(this.props.socketDataStatic[index1].C) === 32 ? this.getStkWiseMarkup(this.props.socketDataStatic[index1].I, this.props.socketDataStatic[index1].BSID, this.props.stkWiseMarkup)
      : this.getStkWiseMarkup(unit[0], this.props.socketDataStatic[index1].I, this.props.stkWiseMarkup);
      this.setState({ convFactor: tmpConvFactor });
      this.setState({ MEASURE: unit });
      this.setState({ selectedMeasureMkt: unit[0] });
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (T1 === stk_type && type === unit[0]) {
          const DF = this.props.trdPanelData[index].DF;
          const conv_Factor = this.props.trdPanelData[index].F;
          const DFParse = JSON.parse(DF);
          this.setState({ DFMKT: DFParse });
          this.setState({ convFact: conv_Factor });
        } else if ((this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 1) ||
          (this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 2) || this.props.socketDataStatic[index1].C === 32) {
          const DF = this.props.socketDataStatic[index1].DF;
          const DFParse = JSON.parse(DF);
          this.setState({ DFMKT: DFParse });
        }
      }
      if (this.props.socketDataStatic[index1].B === 1) {
        this.setState({ rateToolTip: false });
      } else if (this.props.socketDataStatic[index1].C === 32) {
        this.setState({ rateToolTip: false });
      } else {
        if (this.props.userDetail.showStock === "0") {
          this.setState({ rateToolTip: false });
        } else {
          if (unit[0].toUpperCase() === 'OZ') {
            this.setState({ rateToolTip: false });
          } else {
            this.setState({ rateToolTip: true });
          }
        }
      }
      this.props.subscribeTier(this.props.socketDataStatic[index1].I, this.props.webSocketFlag);
      var tempArray = JSON.parse(localStorage.getItem('trdPnlCmdty')).array;
      tempArray.push(this.props.socketDataStatic[index1].I);
      var obj = { "array": tempArray };
      localStorage.setItem('trdPnlCmdty', JSON.stringify(obj));
    }
    catch (e) {
      console.log(e);
    }
    // console.log("orderStatus "+this.props.orderStatus);
    const showPrice = this.props.userDetail.showPrice === undefined || this.props.userDetail.showPrice === "undefined" ? "BOTH" : this.props.userDetail.showPrice;
    this.setState({ showPrice: showPrice });
  }

  getStkWiseMarkup = (stk_code, cmdty, stkWiseMarkup) => {
    try{
      if (stk_code !== undefined) {
        if (stkWiseMarkup !== null) {
          let stkCodeMarkup = stkWiseMarkup.get(cmdty);
          if (stkCodeMarkup !== undefined) {
            for (let i = 0; i < stkCodeMarkup.length; i++) {
              if (stkCodeMarkup[i].SC === stk_code) {
                this.setState({ stkWiseAskMarkup: stkCodeMarkup[i].ASK, stkWiseBidMarkup: stkCodeMarkup[i].BID });
              }
            }
          }
        }
      } else {
        this.setState({ stkWiseAskMarkup: 0, stkWiseBidMarkup: 0 });
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"TradePanelComponent"});
    }
  }

  componentWillUnmount() {
    this.setState({ mount: false });
    var obj = JSON.parse(localStorage.getItem('trdPnlCmdty'));
    if (obj !== null) {
      var tempArray = obj.array;
      if (tempArray !== null) {
        for (var i = tempArray.length - 1; i >= 0; i--) {
          if (tempArray[i] === this.state.cmdtyID) {
            tempArray.splice(i, 1);
            break;
          }
        }
        if (tempArray.indexOf(this.state.cmdtyID) === -1 && localStorage.getItem('userlogin') != 'null') {
          // this.props.unsubscribeTier(this.state.cmdtyID);
        }
        obj.array = tempArray;
        localStorage.setItem('trdPnlCmdty', JSON.stringify(obj));
        this.setState({ cmdtyID: this.state.selectedCmdty });
      }
    }
  }

  onBlurMKTRmk = (event) => {
    try{
      const rmk = event.target.value;
      this.setState({ selectedRmk: rmk });
      // this.setState({selectedRmkINPUT:rmk});
      this.checkInputData(this.state.cmdtyID, this.state.selectedQuantityMkt, this.state.selectedMeasureMkt, rmk);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurMKTRmk', component:"TradePanelComponent"});
    }
  }

  getWsDataSellBuy = (QT, CmdtyId, Quantity, Measure, DealType, price, OrderType, OMT, PCT, Remark, Validty, CTID, baseRate, baseInstId, tempTS) => {
    try{
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet = JSON.parse(localStorage.getItem('DFA'));
      if (user === null) {
        dispatch(sessionTimeout());
      }
      const platform = localStorage.getItem('platform');
      let priceValue = price;
      let quant = Quantity;
      if (!priceValue) {
        priceValue = 0;
      }
      if (quant === '') {
        quant = 0;
      }
      var obj = {};
      obj.language = navigator.language;
      obj.platform = platform;
      obj.browser = navigator.userAgent
      obj.MT = "NEW_ORDER";
      obj.UID = user.UID;
      obj.UCD = user.trdCode;
      obj.UD = user.UD;
      obj.IID = CmdtyId;
      obj.QT = QT;
      obj.PQ = parseFloat(quant);
      obj.DT = DealType;
      obj.R = parseFloat(priceValue);
      obj.OT = OrderType;
      obj.CID = user.location;
      obj.AC = AccDet.C;
      obj.AD = AccDet.D;
      if (Measure === "") {
        obj.SC = "";
      } else {
        obj.SC = Measure;
      }
      obj.OMT = OMT;
      obj.PCT = PCT;
      obj.UUID = user.authToken;
      obj.RMK = Remark;
      obj.CR = priceValue;
      obj.VD = Validty;
      obj.SID = user.SID;
      obj.CTID = CTID;
      obj.MD = -1;
      obj.BSR = baseRate;
      obj.BSIID = baseInstId;
      obj.tempTS = tempTS;
      return obj
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getWsDataSellBuy', component:"TradePanelComponent"});
    }
  }
  checkInputData = (cmdtyId, quantity, sc, rmk) => {
    try{
      let inputData = {
        IID: cmdtyId,
        PQ: quantity,
        SC: sc,
        // R:price,
        // VD:ValueDate,
        // BSR:baseRate,
        // BSIID:baseInstId,
        RMK: rmk,
        language: navigator.language,
        platform: localStorage.getItem('platform'),
        MT: "NEW_ORDER",
        browser: navigator.userAgent
      }
      this.setState({ inputData })
      // console.log("inputData "+ JSON.stringify(inputData));
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkInputData', component:"TradePanelComponent"});
    }
  }
  orderValidate = (QT, Com, selectedQuantity, selectedMeasure, price, ValueDate, dealType, baseRate, baseInstId, tempTS) => {
    try{
      // console.log(inputData)
      var selectedQuantity = selectedQuantity;
      selectedQuantity = unformatLang(selectedQuantity);
      selectedQuantity = selectedQuantity + "";
      var tempQ = selectedQuantity;
      var check = selectedQuantity.slice(selectedQuantity - 1);
      const defaultAcc = getDefaultAcdAccount(this.props.ACD)
      if (check.toUpperCase() === 'K') {
        tempQ = selectedQuantity.slice(check, -1);
        tempQ = parseInt(tempQ) * 1000;
      }
      let flag = 0;
      this.setState({ qtyErrorMsg: "" });
      this.setState({ qtyTypErrMsg: "" });
      this.setState({ statusErrMsg: "" });
      this.setState({
        defaultAccountIsActive: Boolean(Number(defaultAcc.isActiveAcc)),
      });
      if (parseInt(this.props.status) !== 0) {
        this.setState({ statusErrMsg: 'noRatesMsg' });
      }
      if (parseFloat(tempQ) === 0) {
        flag = 1;
        this.setState({ qtyErrorMsg: 'minEnterQty' });
      }
      if (selectedMeasure === '') {
        flag = 1;
        this.setState({ qtyTypErrMsg: 'selectQtyTypeMsg' });
      }
      if (tempQ === '') {
        flag = 1;
        this.setState({ qtyErrorMsg: "minEnterQty" });
      }
      if (this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0) {
        flag = 1;
        this.setState({ qtyErrorMsg: "fractionDigitErrMsg" });
      }

      if (flag === 1) {
        this.setState({ showDialog: true });
      } else {
        if (this.props.orderStatus === 2 || this.props.orderStatus === 1) {
          this.setState({ orderSocketClosed: true });
        } else if (Number(defaultAcc.isActiveAcc) && this.props.userDetail.canTrade === true) {
          this.setState({ isButtonDisabled: true });
          const user = JSON.parse(localStorage.getItem('user'));
          var sd = moment();
          sd.utc().valueOf();
          var currCTID = user.location + "_" + sd;
          this.state.CTID.push(currCTID);
          if (this.props.trdCTID === null || this.props.trdCTID === 'null') {
            this.changeTrdCtid(currCTID);
            this.handleOrder(QT, this.state.COM, this.state.cmdtyID, selectedQuantity, selectedMeasure, dealType, price, 1, ValueDate, this.state.selectedRmk, currCTID, baseRate, baseInstId, tempTS)

          } else {
            let prevCtid = this.props.trdCTID.toString().split('_')
            let currCtid = currCTID.toString().split('_')
            var secDiff = Math.floor((currCtid[1] - prevCtid[1]) / 1000)
            if (secDiff < 15) {
              this.props.closeWebSocketTrade();
              this.setState({ trdProgressFlg: true })
            } else {
              this.setState({ netIssueFlg: true })
            }
          }
        } else {
          this.setState({ showtrdFlagModal: true });
        }
      }
      if (this.props.userDetail.storetradeqty === "0") {
        this.setState({ selectedQuantityMkt: "" });
        this.setState({ selectedActualMktQty: "" });
      }
      this.refs.commentMkt.value = "";
      this.setState({ selectedRmk: "" });
      setTimeout(function () {
        this.setState({ isButtonDisabled: false })
      }.bind(this), 5000);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'orderValidate', component:"TradePanelComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { tab: "MKT", originFunction: "handleOrder", event: appConstants.trackingEvents.PLACE_TRADE},
    ordDetails: [wsData]
  }))

  handleOrder = (QT, Com, CmdtyPair, selectedQuantity, selectedMeasure, DealType, Price, OrderType, ValueDate, rmk, CTID, baseRate, baseInstId, tempTS) => {
    try{
      selectedQuantity = selectedQuantity + "";
      var tempQ = selectedQuantity;
      var check = selectedQuantity.slice(selectedQuantity - 1);
      if (check.toUpperCase() === 'K') {
        tempQ = selectedQuantity.slice(check, -1);
        tempQ = parseInt(tempQ) * 1000;
      }
      if (Com === 1 || this.state.isCustInst) {
        selectedMeasure = "";
      }
      var OMT;
      var PCT;
      const remark = rmk;
      if (OrderType === 1) {
        OMT = 1;
        PCT = 1;
      }
      // this.setState({showCnfrmMsg: true});
      let processedData={
        QT:QT,
        IID:CmdtyPair,
        PQ:tempQ,
        SC:selectedMeasure,
        DT:DealType,
        R:Price,
        OT:OrderType,
        OMT:OMT,
        PCT:PCT,
        RMK:remark,
        VD:ValueDate,
        CTID:CTID,
        BSR:baseRate,
        BSIID:baseInstId,
        language:navigator.language,
        platform:localStorage.getItem('platform'),
        MT:"NEW_ORDER",
        browser:navigator.userAgent,
        tempTS:tempTS
        }
      this.setState({processedData})
      this.props.handleSellBuyOrder(QT, CmdtyPair, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, ValueDate, CTID, baseRate, baseInstId,tempTS);
      wsData=this.getWsDataSellBuy(QT, CmdtyPair, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, ValueDate, CTID, baseRate, baseInstId,tempTS)
      let inputData=this.state.inputData
      let apiValidateData=[{inputData},{processedData},{wsData}]
      this.props.validateOrder(JSON.stringify(apiValidateData))
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleOrder', component:"TradePanelComponent"});
    }
  }

  closeModal = (event) => {
    try{
      this.setState({ showDialog: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"TradePanelComponent"});
    }
  }

  closeTrdFlagModal = (event) => {
    try{
      this.setState({ showtrdFlagModal: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeTrdFlagModal', component:"TradePanelComponent"});
    }
  }

  closecmdtyLimitModal = (event) => {
    try{
      this.setState({ cmdtyLimit: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closecmdtyLimitModal', component:"TradePanelComponent"});
    }
  }

  cmdtySelection = (event, cmdtyId) => {
    try{
      var cmdtyArr = [];
      this.props.layout.map((item) => {
        let str = item.i;
        str = str.substring(0, str.indexOf('-'));
        switch (str) {
          case 'Trade':
            cmdtyArr.push(item.cmdtyPair);
            break;
          default:
            break;
        }
      });
      var exceedCmdty = [];
      var copy = cmdtyArr.slice(0);
      for (var i = 0; i < cmdtyArr.length; i++) {
        var cnt = 0;
        for (var j = 0; j < copy.length; j++) {
          if (cmdtyArr[i] == copy[j]) {
            cnt++;
            delete copy[j];
          }
        }
        if (cnt >= 5) {
          exceedCmdty.push(cmdtyArr[i]);
        }
      }
      var flag = 0;
      for (var l = 0; l < exceedCmdty.length; l++) {
        if (exceedCmdty[l] == event) {
          flag = 1;
        }
      }
      if (flag == 1) {
        this.setState({ cmdtyLimit: true });
      } else {
        this.props.changeCmdyPair(event, this.props.keyValue, this.props.layout, this.state.key);
        this.setState({ selectedCmdty: event });
        // this.setState({selectedCmdtyINPUT:event});
        this.setState({ cmdtyID: event });
        const length = this.props.socketDataStatic.length;
        let index1;
        for (let index = 0; index < length; index++) {
          const cmdty = this.props.socketDataStatic[index].I;
          const cmdtyDes = this.props.socketDataStatic[index].ID;
          if (event === cmdty) {
            index1 = index;
          }
        }
        this.setState({ COM: parseInt((this.props.socketDataStatic[index1]).B) });
        const T1 = this.props.socketDataStatic[index1].T1;
        this.setState({ T1: T1 });
        // const DF=this.props.socketDataStatic[index1].DF;
        // const DFParse=JSON.parse(DF);
        // this.setState({DFMKT: DFParse});
        // this.setState({DFBM: DFParse});
        const unit = [];
        var tmpConvFactor = new Map();
        const lengthTrdData = this.props.trdPanelData.length;
        for (let index = 0; index < lengthTrdData; index++) {
          const stk_type = this.props.trdPanelData[index].stk_type;
          if (stk_type === T1) {
            unit.push(this.props.trdPanelData[index].C);
            tmpConvFactor.set(this.props.trdPanelData[index].C, this.props.trdPanelData[index].F)
          }
        }
        /// conversion factor for custom instrument
        if (this.props.custInstStkData !== undefined) {
          for (let index = 0; index < this.props.custInstStkData.length; index++) {
            const stk_type = this.props.custInstStkData[index].stk_type;
            if (stk_type === T1) {
              tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
            }
          }
        }
        for (let index = 0; index < lengthTrdData; index++) {
          const stk_type = this.props.trdPanelData[index].stk_type;
          const type = this.props.trdPanelData[index].C;
          if (T1 === stk_type && type === unit[0]) {
            const DF = this.props.trdPanelData[index].DF;
            const DFParse = JSON.parse(DF);
            this.setState({ DFMKT: DFParse });
            this.setState({ DFBM: DFParse });
          } else if ((this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 1) ||
            (this.props.socketDataStatic[index1].B === 1 && this.props.socketDataStatic[index1].C === 2) || this.props.socketDataStatic[index1].C === 32) {
            const DF = this.props.socketDataStatic[index1].DF;
            const DFParse = JSON.parse(DF);
            this.setState({ DFMKT: DFParse });
          }
        }
        parseInt(this.props.socketDataStatic[index1].C) === 32 ? this.getStkWiseMarkup(this.props.socketDataStatic[index1].I, this.props.socketDataStatic[index1].BSID, this.props.stkWiseMarkup)
        : this.getStkWiseMarkup(unit[0], this.props.socketDataStatic[index1].I, this.props.stkWiseMarkup);
        this.setState({convFactor:tmpConvFactor});
        this.setState({MEASURE:unit});
        this.setState({selectedMeasureMkt:unit[0]});
        this.props.subscribeTier(event,true);
        this.props.layoutChanged();
        this.closeOrdConfirmMsg();
        this.checkInputData(event, this.state.selectedQuantityMkt, this.state.selectedMeasureMkt, this.state.selectedRmk);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cmdtySelection', component:"TradePanelComponent"});
    }
  }

  closeWidget = (keyValue) => {
    try{
      this.setState({ clickedRemove: true });
      this.props.layoutChanged(1);
      this.props.deleteWidget(keyValue);
      var count = this.props.tradeWidgetCnt;
      count--;
      this.props.tradeCnt(count);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"TradePanelComponent"});
    }
  }

  quantitySelectionMkt = (event) => {
    try {
      if (event.target.text === "") {
        event.target.text = "0"
      }
      var check = event.target.text.slice(event.target.text.length - 1);
      var tempQ = event.target.text;
      if (check.toUpperCase() === 'K') {
        tempQ = event.target.text.slice(check, -1);
        tempQ = parseFloat(tempQ) * 1000;
      } else if (check.toUpperCase() === 'M') {
        tempQ = event.target.text.slice(check, -1);
        tempQ = parseFloat(tempQ) * 1000000;
      }
      //convFactor
      let qty = (tempQ).toLocaleString(navigator.language, { minimumFractionDigits: 3, maximumFractionDigits: 3 });
      // qty=(qty).replace(getSeparator(navigator.language, 'group'), "");
      this.setState({ selectedQuantityMkt: qty });
      this.checkInputData(this.state.cmdtyID, qty, this.state.selectedMeasureMkt, this.state.selectedRmk)
      // this.setState({selectedQuantityMktINPUT:event.target.text});
      if (this.state.COM === 1 && !this.state.isCustInst) {
        tempQ = parseFloat(tempQ);
      } else if (this.state.isCustInst) {
        tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.cmdtyID));
      } else {
        tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
      }
      // tempQ = tempQ.toFixed(2);
      this.setState({ selectedActualMktQty: tempQ });
      if (tempQ < 10 && tempQ > 0) {
        this.props.subscribeTier(this.state.cmdtyID, true);
      }

    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionMkt', component:"TradePanelComponent"});
    }
  }

  checkNumberValue = (event) => {
    try{
      let decimalCount;
      //Disallow typing of characters other than numbers and comma and dot
      if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which) !== separator) && (String.fromCharCode(event.which) !== decimal) && (event.which !== 107) && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)) {
        event.preventDefault();
      }
      //If, at any point if the entered value has no decimal, keep decimalCount as 0
      if (event.target.value.indexOf(decimal) === -1) {
        decimalCount = 0;
      }
      //Do no allow typing of seperator based on locale and decimal(based on locale) more than once
      // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount >= 1)) {
      //   event.preventDefault();
      // }
      //If more than once decimal is typed, increment counter
      if (event.which === decimal.charCodeAt(0)) {
        decimalCount += 1;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"TradePanelComponent"});
    }
  }

  quantityTypedMkt = (event) => {
    try{
      var checkDecimal = getSeparator(navigator.language, 'decimal');
      var checkDecimalInput = event.target.value;
      if (checkDecimalInput.indexOf(checkDecimal) !== -1) {
        checkDecimalInput = unformatLang(checkDecimalInput);
      } else {
        checkDecimalInput = event.target.value;
      }
      if (event.target.value.charAt(0) === checkDecimal) {
        event.target.value = "0" + checkDecimal;
        checkDecimalInput = "0" + checkDecimalInput;
      }

      var flag = 0;
      var c = 0;
      for (var i = 0; i < event.target.value.length; i++) {
        if (event.target.value.charAt(i) === checkDecimal) {
          flag = 1;
        }
        if (flag == 1) {
          c++;
        }
      }
      if (c > 4) {
        event.target.value = this.state.selectedQuantityMkt;
      }
      if (!(event.target.value.charAt(0).toUpperCase() === 'K' || event.target.value.charAt(0).toUpperCase() === 'M')) {
        var check = event.target.value.slice(event.target.value.length - 1);
        var tempQ = event.target.value;
        if (check.toUpperCase() === 'K') {
          tempQ = event.target.value.slice(check, -1);
          tempQ = parseFloat(tempQ) * 1000;
        } else if (check.toUpperCase() === 'M') {
          tempQ = event.target.value.slice(check, -1);
          tempQ = parseFloat(tempQ) * 1000000;
        }
        if (!isNaN(tempQ)) {
          this.setState({ selectedQuantityMkt: (tempQ).toLocaleString(navigator.language, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) });
          if (this.state.COM === 1 && !this.state.isCustInst) {
            if (tempQ != '') {
              tempQ = parseFloat(tempQ);
            }
          } else if (this.state.isCustInst) {
            tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.cmdtyID));
          } else {
            tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
          }
          this.setState({ selectedActualMktQty: tempQ });
        } else {
          this.setState({ selectedActualMktQty: unformatLang(event.target.value) });
          this.setState({ selectedQuantityMkt: event.target.value });
        }
      } else {
        this.setState({ selectedActualMktQty: unformatLang(event.target.value) });
        this.setState({ selectedQuantityMkt: event.target.value });
      }

      if (tempQ < 10 && tempQ > 0) {
        this.props.subscribeTier(this.state.cmdtyID, true);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantityTypedMkt', component:"TradePanelComponent"});
    }
  }

  selectMeasureMkt = (event) => {
    try{
      this.setState({ selectedMeasureMkt: event.target.text });
      // this.setState({selectedMeasureMktINPUT:event.target.text});
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1 === stk_type && type === event.target.text) {
          const DF = this.props.trdPanelData[index].DF;
          const conv_Factor = this.props.trdPanelData[index].F;
          const DFParse = JSON.parse(DF);
          this.setState({ DFMKT: DFParse });
          this.setState({ convFact: conv_Factor });
        }
      }
      this.getStkWiseMarkup(event.target.text, this.state.cmdtyID, this.props.stkWiseMarkup);
      if (this.props.userDetail.showStock === "1") {
        if ((event.target.text).toUpperCase() === 'OZ') {
          this.setState({ rateToolTip: false });
        } else if (this.state.isCustInst) {
          this.setState({ rateToolTip: false });
        } else {
          this.setState({ rateToolTip: true });
        }
      } else {
        this.setState({ rateToolTip: false });
      }
      var selectedQty = 0;
      if (this.state.selectedQuantityMkt === "") {
        selectedQty = 0;
      } else {
        selectedQty = this.state.selectedQuantityMkt;
      }
      var tempQ = parseFloat(selectedQty) * parseFloat(this.state.convFactor.get(event.target.text));
      // tempQ = tempQ.toFixed(2);
      this.setState({ selectedActualMktQty: tempQ });
      this.checkInputData(this.state.cmdtyID, this.state.selectedQuantityMkt, event.target.text, this.state.selectedRmk)
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureMkt', component:"TradePanelComponent"});
    }
  }

  onBlurMKT = (event) => {
    try{
      // var tempQ = (event.target.value).replace(getSeparator(navigator.language, 'decimal'), getSeparator('en-US', 'decimal'));
      var tempQ = event.target.value;
      tempQ = unformatLang(tempQ);
      // console.log("tempQ"+tempQ);

      if (tempQ === "") {
        tempQ = "";
      }
      if (event.target.value.charAt(0) === getSeparator(navigator.language, 'decimal')) {
        event.target.value = "0" + event.target.value;
      }
      if (!(event.target.value.charAt(0).toUpperCase() === 'K' || event.target.value.charAt(0).toUpperCase() === 'M')) {
        var check = event.target.value.slice(event.target.value.length - 1);
        tempQ = event.target.value;
        tempQ = unformatLang(tempQ);
        if (check.toUpperCase() === 'K') {
          tempQ = event.target.value.slice(check, -1);
          tempQ = parseFloat(tempQ) * 1000;
        } else if (check.toUpperCase() === 'M') {
          tempQ = event.target.value.slice(check, -1);
          tempQ = parseFloat(tempQ) * 1000000;
        }
        if (!isNaN(tempQ) && tempQ !== "" && tempQ !== 0) {
          tempQ = event.target.value;
          tempQ = unformatLang(tempQ);
          if (tempQ === "" || tempQ === "NaN") {
            tempQ = "";
          }
          var tempQuant = Number(parseFloat(tempQ)).toLocaleString(navigator.language, { minimumFractionDigits: 3, maximumFractionDigits: 3 });
          // var tempQuant=Number.isInteger(parseFloat(tempQ)) ? tempQ : Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3});
          // tempQuant=unformatLang(tempQuant);
          // console.log("tempQ"+tempQuant);
          this.setState({ selectedQuantityMkt: tempQuant });
          // tempQuant=unformatLang(tempQuant);
          this.checkInputData(this.state.cmdtyID, tempQuant, this.state.selectedMeasureMkt, this.state.selectedRmk);
          // this.setState({selectedQuantityMktINPUT:event.target.value});
          if (this.state.COM === 1 && !this.state.isCustInst) {
            tempQ = parseFloat(tempQ);
          } else if (this.state.isCustInst) {
            tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.cmdtyID));
          } else {
            tempQ = tempQ * parseFloat(this.state.convFactor.get(this.state.selectedMeasureMkt));
          }
          // tempQ = tempQ.toFixed(2);
          this.setState({ selectedActualMktQty: tempQ });
          //this.setState({selectedActualMktQty:Number.isInteger(parseFloat(tempQ)) ? tempQ : Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3,maximumFractionDigits:3})});
        } else {
          if (tempQ === "") {
            tempQ = "";
          }
          if (tempQ === "NaN") {
            tempQ = "";
          }
          if (event.target.value === "") {
            tempQ = "";
          }
          this.setState({ selectedActualMktQty: tempQ });
          this.setState({ selectedQuantityMkt: tempQ });
          // this.setState({selectedQuantityMktINPUT:event.target.value});
          // console.log("MKTQty"+tempQ);
          this.checkInputData(this.state.cmdtyID, tempQ, this.state.selectedMeasureMkt, this.state.selectedRmk);
        }
      } else {
        if (tempQ === "") {
          tempQ = " ";
        }
        if (!isNaN(tempQ)) {
          this.setState({ selectedActualMktQty: tempQ });
          // this.setState({selectedQuantityMktINPUT:event.target.value});
          tempQ = Number.isInteger(parseFloat(tempQ)) ? tempQ : Number(parseFloat(tempQ)).toLocaleString(navigator.language, { minimumFractionDigits: 3, maximumFractionDigits: 3 });
          //this.setState({selectedActualMktQty:Number.isInteger(parseFloat(tempQ)) ? tempQ : Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3})});
          this.setState({ selectedQuantityMkt: tempQ });
          this.checkInputData(this.state.cmdtyID, tempQ, this.state.selectedMeasureMkt, this.state.selectedRmk);
        }
        else {
          this.setState({ selectedActualMktQty: tempQ });
          this.setState({ selectedQuantityMkt: tempQ });
          // this.setState({selectedQuantityMktINPUT:event.target.value});
          this.checkInputData(this.state.cmdtyID, tempQ, this.state.selectedMeasureMkt, this.state.selectedRmk);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurMKT', component:"TradePanelComponent"});
    }
  }

  setordConfirmMsg = () => {
    try{
      this.setState({ ordConfirmMsg: this.props.ordcnfrmsg });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setordConfirmMsg', component:"TradePanelComponent"});
    }
  }

  changebuttonState = (event) => {
    try{
      this.setState({ isButtonDisabled: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changebuttonState', component:"TradePanelComponent"});
    }
  }

  closeOrdConfirmMsg = () => {
    try{
      this.setState({ showCnfrmMsg: false });
      if (this.state.key === 2) {
        this.setState({ isSubmitDisabled: false });
      }
      this.props.closeOrdConfirmMsg();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeOrdConfirmMsg', component:"TradePanelComponent"});
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    //*************Apply theme colour change*********************************
    //const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = nextProps.selectedCssColorTheme;
    // if (this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme) {
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);

    //   applyClickActive(thisComponent.getElementsByTagName("li"), allCssStyleRules);
    //   const hoverElementsClassNames = [
    //     { "elmToHover": thisComponent.getElementsByClassName('closeBtn')[0], "classNames": "closeBtn" },
    //     { "elmToHover": thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames": "vericalDotIcon" }
    //     //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this), directionData, nextProps.selectedLang);
    }
    //***********************************************************************
    if (nextProps.lmtKeyValue === this.props.keyValue) {
      if (this.state.LmtClicked !== nextProps.closeLmtFlag) {
        this.setState({ LmtClicked: nextProps.closeLmtFlag });
      }
    }

    if (nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo) {
      nextProps.instData.get(this.state.cmdtyID).C === 32 
      ? this.getStkWiseMarkup(this.state.cmdtyID, nextProps.instData.get(this.state.cmdtyID).BIID, nextProps.stkWiseMarkup)
      : this.getStkWiseMarkup(this.state.selectedMeasureMkt, this.state.cmdtyID, nextProps.stkWiseMarkup);
    }
    if (this.state.deleteWidget !== nextProps.deleteWidgetKey) {
      this.setState({ clickedRemove: false });
      this.setState({ deleteWidget: nextProps.deleteWidgetKey });
    }
    if (nextProps.userDetail.showStock === '1') {
      if (this.state.COM === 1) {
        this.setState({ rateToolTip: false });
      } else if ((this.state.selectedMeasureMkt).toUpperCase() === 'OZ') {
        this.setState({ rateToolTip: false });
      } else if (this.state.isCustInst) {
        this.setState({ rateToolTip: false });
      } else {
        this.setState({ rateToolTip: true });
      }
    } else {
      this.setState({ rateToolTip: false });
    }

    if (this.state.showStock !== nextProps.userDetail.showStock) {
      this.setState({ showStock: nextProps.userDetail.showStock });
    }
    if (this.props.ordcnfrmsg.CTID !== nextProps.ordcnfrmsg.CTID) {
      if (nextProps.ordcnfrmsg.CTID !== undefined) {
        if (this.state.CTID.indexOf(nextProps.ordcnfrmsg.CTID) !== -1) {
          //this.setState({lmtCnfrmMsgBoxFlag:false});
          this.changebuttonState();
          this.setState({ showCnfrmMsg: true });
          this.setState({ ordConfirmMsg: nextProps.ordcnfrmsg })
        }
      }
      // else {
      //   console.log(" limit order ");
      //   if(nextProps.ordcnfrmsg.remark1 !== undefined){
      //     this.setState({lmtCnfrmMsgBoxFlag :true});
      //   }
      //
      // }
    }
    if (nextProps.check !== this.props.check) {
      let SocketDataObj = this.props.socketData.get(this.state.selectedCmdty);
      let calRateConv;
      let calRateConv_Sell;
      let rateConvRoundOFF;
      let rateConvRoundOFF_sell;
      if (this.state.rateToolTip === true) {
        calRateConv = (parseFloat(SocketDataObj.ask) - this.state.stkWiseAskMarkup) * parseFloat(this.state.convFact);
        calRateConv_Sell = (parseFloat(SocketDataObj.bid) - this.state.stkWiseBidMarkup) * parseFloat(this.state.convFact);
        rateConvRoundOFF = Number(parseFloat(calRateConv)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits: config.AmountRoundOFF });
        rateConvRoundOFF_sell = Number(parseFloat(calRateConv_Sell)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits: config.AmountRoundOFF });
        this.setState({ rateConvRoundOFFAsk: rateConvRoundOFF });
        this.setState({ rateConvRoundOFFBid: rateConvRoundOFF_sell });
      }
    }
    if (nextProps.userDetail.showPrice !== this.state.showPrice) {
      if (nextProps.userDetail.showPrice !== undefined && nextProps.userDetail.showPrice !== "undefined") {
        const showPrice = nextProps.userDetail.showPrice === undefined || nextProps.userDetail.showPrice === "undefined" ? "BOTH" : nextProps.userDetail.showPrice;
        this.setState({ showPrice: showPrice });
      }
    }
    if (nextProps.fixKeyValue === this.props.keyValue) {
      if (this.state.FixClicked !== nextProps.closeFixFlag) {
        this.setState({ FixClicked: nextProps.closeFixFlag });
      }
    }
  }

  closeLmtModal = (event) => {
    try{
      this.props.closedLmtModal(false);
      this.setState({ componentKey: 1 });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLmtModal', component:"TradePanelComponent"});
    }
  }

  onKeyPress(event) {
    try{
      if (event.which === 13 /* Enter */) {
        event.preventDefault();
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onKeyPress', component:"TradePanelComponent"});
    }
  }

  closeTrdFlagModal = (event) => {
    try{
      this.setState({ showtrdFlagModal: false, defaultAccountIsActive: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeTrdFlagModal', component:"TradePanelComponent"});
    }
  }

  handleSelect = (key1) => {
    try{
      this.setState({ key: 1 });
      this.setState({ componentKey: 1 });
      if (key1 === 2) {
        this.setState({ LmtClicked: true });
        this.setState({ componentKey: 2 });
        this.props.closedLmtModal(true, this.props.keyValue);
      }
      else if (key1 === 3) {
        this.setState({ FixClicked: true });
        this.setState({ componentKey: 3 });
        this.props.closedFixModal(true, this.props.keyValue);

      }
      // this.closeOrdConfirmMsg();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleSelect', component:"TradePanelComponent"});
    }
  }

  gridType = () => {
    try{
      this.setState({ showGridOptions: !this.state.showGridOptions });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'gridType', component:"TradePanelComponent"});
    }
  }

  closeGridType = () => {
    try{
      this.setState({ showGridOptions: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeGridType', component:"TradePanelComponent"});
    }
  }

  onClick = (e, data) => {
    try{
      this.props.resizeTradePanel(data.rowNumber + 1, data.columnNumber + 1, this.props.keyValue);
      this.setState({ showGridOptions: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClick', component:"TradePanelComponent"});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.key !== this.state.key) {
      return true;
    }
    if (nextProps.check !== this.props.check) {
      return true;
      // if (this.props.socketData.get(this.state.selectedCmdty) !== nextProps.socketData.get(this.state.selectedCmdty)) {
      //   return true;
      // }
    }
    if (nextProps.status !== this.props.status) {
      return true;
    }
    if (nextProps.ordcnfrmsg !== this.props.ordcnfrmsg) {
      return true;
    }
    if (nextProps.trdingFlag !== this.props.trdingFlag) {
      return true;
    }
    if (nextState.showStock !== this.state.showStock) {
      return true;
    }
    if (nextState.convFactor !== this.state.convFactor) {
      return true;
    }
    if (nextState.qtyErrorMsg !== this.state.qtyErrorMsg) {
      return true;
    }
    if (nextState.qtyTypErrMsg !== this.state.qtyTypErrMsg) {
      return true;
    }
    if (nextState.statusErrMsg !== this.state.statusErrMsg) {
      return true;
    }
    if (nextState.rateToolTip !== this.state.rateToolTip) {
      return true;
    }
    if (nextState.CTID !== this.state.CTID) {
      return true;
    }
    if (nextState.isButtonDisabled !== this.state.isButtonDisabled) {
      return true;
    }
    if (nextState.isSubmitDisabled !== this.state.isSubmitDisabled) {
      return true;
    }
    if (nextState.showDialog !== this.state.showDialog) {
      return true;
    }
    if (nextState.showtrdFlagModal !== this.state.showtrdFlagModal) {
      return true;
    }
    if (nextState.selectedRmk !== this.state.selectedRmk) {
      return true;
    }
    if (nextState.selectedQuantityMkt !== this.state.selectedQuantityMkt) {
      return true;
    }
    if (nextState.selectedMeasureMkt !== this.state.selectedMeasureMkt) {
      return true;
    }
    if (nextState.selectedActualMktQty !== this.state.selectedActualMktQty) {
      return true;
    }
    if (nextState.selectedMeasure !== this.state.selectedMeasure) {
      return true;
    }
    if (nextState.DealType !== this.state.DealType) {
      return true;
    }
    if (nextState.Quantity !== this.state.Quantity) {
      return true;
    }
    if (nextState.cmdtyID !== this.state.cmdtyID) {
      return true;
    }
    if (nextState.clickedRemove !== this.state.clickedRemove) {
      return true;
    }
    if (nextState.selectedCmdty !== this.state.selectedCmdty) {
      return true;
    }
    if (nextState.showCnfrmMsg !== this.state.showCnfrmMsg) {
      return true;
    }
    if (nextState.MEASURE !== this.state.MEASURE) {
      return true;
    }
    if (nextProps.deleteWidgetKey !== this.props.deleteWidgetKey) {
      return true;
    }
    if (this.state.deleteWidget !== nextState.deleteWidget) {
      return true;
    }
    if (this.state.LmtClicked !== this.props.closeLmtFlag) {
      return true;
    }

    if (this.state.componentKey !== nextState.componentKey) {
      return true;
    }
    if (this.state.selectedCmdty !== this.state.selectedCmdty) {
      return true;
    }
    if (this.state.cmdtyPair !== this.props.cmdtyPair) {
      return true;
    }
    if (nextProps.userDetail !== this.props.userDetail) {
      return true;
    }
    if (this.state.rateConvRoundOFFAsk !== nextState.rateConvRoundOFFAsk) {
      return true;
    }
    if (this.state.rateConvRoundOFFBid !== nextState.rateConvRoundOFFBid) {
      return true;
    }
    if (nextprops.userDetail.fontSize !== this.props.userDetail.fontSize) {
      return true;
    }
    if (nextprops.lmtKeyValue !== this.props.lmtKeyValue) {
      return true;
    }
    if (nextprops.fixKeyValue !== this.props.fixKeyValue) {
      return true;
    }
    if (this.state.cmdtyLimit !== nextState.cmdtyLimit) {
      return true;
    }
    if (nextProps.trdCTID !== this.props.trdCTID) {
      return true;
    }
    if (this.state.trdProgressFlg !== nextState.trdProgressFlg) {
      return true;
    }
    if (this.state.netIssueFlg !== nextState.netIssueFlg) {
      return true;
    }
    if (this.state.FixClicked !== this.props.closeFixFlag) {
      return true;
    }
    // if(nextState.lmtCnfrmMsgBoxFlag !== this.state.lmtCnfrmMsgBoxFlag) {
    //   return true;
    // }
    return false;
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   { "classNames": "header", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      //   { "classNames": "closeBtn", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      //   { "classNames": "warningModal", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      //   { "classNames": "msg", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      //   { "classNames": "mdlWrap", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      //   { "classNames": "caret", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      // ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        { "classNames": "header", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
        { "classNames": "commonCloseIcon", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
        { "classNames": "commonMsgDir", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
        { "classNames": "trdCloseIcon", "elementType": "normal", "applyTo": "all", "tagNames": "div" }
      ];
      setDirection(thisComponent, directionData, this.props.selectedLang);
      const hoverElementsClassNames = [
        { "elmToHover": thisComponent.getElementsByClassName("closeBtn")[0], "classNames": "closeBtn" }
        //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
      ];
      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"TradePanelComponent"});
    }
  }

  //change trade Ctid when trade place.
  changeTrdCtid = (ctid) => {
    try{
      this.props.setTrdCTID(ctid);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeTrdCtid', component:"TradePanelComponent"});
    }
  }

  closeTrdErrorModal = (event) => {
    try{
      this.setState({ trdProgressFlg: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeTrdErrorModal', component:"TradePanelComponent"});
    }
  }

  closeNetIssueErrorModal = (event) => {
    try{
      this.props.setTrdCTID(null);
      this.props.closeSocketData();
      this.props.closeSocketTrade();
      this.props.logout(this.props.userDetail);
      this.setState({ netIssueFlg: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeNetIssueErrorModal', component:"TradePanelComponent"});
    }
  }

  closeorderSocketClosedModal = (event) => {
    try{
      this.setState({ orderSocketClosed: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeorderSocketClosedModal', component:"TradePanelComponent"});
    }
  }


  render() {
    const { CloseIcon, deleteWidgetKey, keyValue } = this.props;
    const { selectedCmdty, selectedMeasureMkt, selectedQuantityMkt,
      selectedActualMktQty, quantityArrayMkt, DFMKT, MEASURE, COM, Price, DealType, Validty,
      OrderType, LmtClicked, FixClicked, showPrice } = this.state;
    let comments = '';
    if (this.props.height > 1) {
      comments = { height: '86px' };
    } else {
      comments = { height: '25px' };
    }
    let buttonAskFlag = false;
    let buttonBidFlag = false;
    let CmdtyAsk;
    let CmdtyBid;
    let CmdtyPair;
    let CmdtyAskArray;
    let CmdtyBidArray;
    let ValueDate;
    let D1;
    let rateDiff;
    let variationInAsk;
    // let ordConfirmMsg1="";
    // let ordConfirmMsg2="";
    var mktQty;
    let index1 = 0;
    let cmdtyPair;
    let QTA;
    let QTB;
    let baseAskPrice, baseBidPrice;
    let baseInstId;
    let CmdtyBidFontPosStart=0;let CmdtyBidFontPosEnd=0;
    let CmdtyAskFontPosStart=0;let CmdtyAskFontPosEnd=0;
    // if(this.state.CTID.indexOf(this.props.ordcnfrmsg.CTID) !== -1) {
    //   ordConfirmMsg1=this.props.ordcnfrmsg.remark1;
    //   ordConfirmMsg2=this.props.ordcnfrmsg.remark2;
    // }

    let formatSelectedQty = selectedActualMktQty;
    //console.log("formatSelectedQty:"+formatSelectedQty)
    let formatActualQty = selectedActualMktQty;
    if (parseFloat(formatSelectedQty) === 0 || formatSelectedQty === "") {
      buttonAskFlag = false;
      buttonBidFlag = false;
    }
    if (selectedCmdty === "") {
      cmdtyPair = this.props.cmdtyPair;
    } else {
      cmdtyPair = this.state.selectedCmdty;
    }
    let SocketObj = this.props.socketData.get(cmdtyPair)
    let tempTS = SocketObj.tempTS;
    baseInstId = SocketObj.BI;
    // let isCustInst = SocketObj.C;
    CmdtyPair = SocketObj.cmdty;
    CmdtyAsk = SocketObj.ask;
    CmdtyBid = SocketObj.bid;
    if(CmdtyAsk){
      CmdtyAsk = (parseFloat(SocketObj.ask) - this.state.stkWiseAskMarkup).toFixed(SocketObj.dec);
    }
    if(CmdtyBid){
      CmdtyBid = (parseFloat(SocketObj.bid) - this.state.stkWiseBidMarkup).toFixed(SocketObj.dec);
    }
    QTA = SocketObj.QTA;
    QTB = SocketObj.QTB;
    if (formatSelectedQty === "") {
      mktQty = 0;
    } else {
      mktQty = formatSelectedQty;
    }
    if (isNaN(mktQty)) {
      buttonAskFlag = true;
      buttonBidFlag = true;
    }
    if (parseFloat(mktQty) > 0) {
      if (SocketObj.Tr_A) {
        if (SocketObj.Tr_A.length > 0) {
          for (var ti = 0; ti < SocketObj.Tr_A.length; ti++) {
            if (parseFloat(SocketObj.Tr_A[ti].Q) >= parseFloat(mktQty)) {
              CmdtyAsk = (SocketObj.Tr_A[ti].M - this.state.stkWiseAskMarkup).toFixed(SocketObj.dec);
              baseAskPrice = SocketObj.Tr_A[ti].BM;
              QTA = SocketObj.Tr_A[ti].QT;
              buttonAskFlag = false;
              break;
            } else {
              buttonAskFlag = true;
            }
          };
        } else if (parseFloat(mktQty) !== 0) {
          buttonAskFlag = true;
        }
      }
      if (SocketObj.Tr_B) {
        if (SocketObj.Tr_B.length > 0) {
          for (var ti = 0; ti < SocketObj.Tr_B.length; ti++) {
            if (parseFloat(SocketObj.Tr_B[ti].Q) >= parseFloat(mktQty)) {
              CmdtyBid = (SocketObj.Tr_B[ti].M - this.state.stkWiseBidMarkup).toFixed(SocketObj.dec);
              baseBidPrice = SocketObj.Tr_B[ti].BM;
              QTB = SocketObj.Tr_B[ti].QT;
              buttonBidFlag = false;
              break;
            } else {
              buttonBidFlag = true;
            }
          };
        } else if (parseFloat(mktQty) !== 0) {
          buttonBidFlag = true;
        }
      }
    }
    var mf = JSON.parse(SocketObj.PTN).mf;
    var rf = JSON.parse(SocketObj.PTN).rf;
    rateDiff = parseFloat(CmdtyBid) && parseFloat(CmdtyAsk) ? Math.abs(Math.round(((parseFloat(CmdtyBid).toFixed(SocketObj.dec) - parseFloat(CmdtyAsk).toFixed(SocketObj.dec))) * mf)).toFixed(rf) : "";
    D1 = SocketObj.D1;
    variationInAsk = SocketObj.variationInAsk;
    ValueDate = SocketObj.VD;
    //const quantity = this.props.socketData[this.state.cmdtyIndex].quantity;
    const variationInBid = SocketObj.variationInBid;
    if (CmdtyBid) {
      CmdtyBidArray = Number(parseFloat(CmdtyBid)).toLocaleString(navigator.language, { minimumFractionDigits: SocketObj.dec }).split('');
      CmdtyBidFontPosStart = CmdtyBidArray.length - JSON.parse(SocketObj.PTN).bs;
      CmdtyBidFontPosEnd = (CmdtyBidArray.length - JSON.parse(SocketObj.PTN).se) - 1;
    }
    if (CmdtyAsk) {
      CmdtyAskArray = Number(parseFloat(CmdtyAsk)).toLocaleString(navigator.language, { minimumFractionDigits: SocketObj.dec }).split('');
      CmdtyAskFontPosStart = CmdtyAskArray.length - JSON.parse(SocketObj.PTN).bs;
      CmdtyAskFontPosEnd = (CmdtyAskArray.length - JSON.parse(SocketObj.PTN).se) - 1;
    }

    const singleClickFlag = this.props.userDetail.isTrdInstant;
    const selectedfont_size = "fontSize_" + this.props.userDetail.fontSize;
    const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`${styles.overLayCloseIcon}`} title={i18next.t("close")}/>;
    // const showPrice = this.props.userDetail.showPric === undefined || this.props.userDetail.showPrice === "undefined" ? "BOTH" : this.props.userDetail.showPrice;
    const stkCodeClass = MEASURE.length == 1 ? true : false;
    const defaultAcc = getDefaultAcdAccount(this.props.ACD)

    return (
      <div className={`${styles.trdwrapper}`}>
        {!this.state.clickedRemove ?
          <div className="trdWidgetwrapper">
            {this.state.componentKey === 2 && this.state.LmtClicked === true ?
              <Modal isOpen={this.state.LmtClicked} className={`${styles.lmtModal} lmtModal`} id="lmtModal" onAfterOpen={this.afterOpenModal}>
                <div ref="errorMSG" className="mdlWrap" >
                  <LimitOrder cmdty={this.state.cmdtyID} />
                </div>
              </Modal>
              : null}

            {this.state.componentKey === 3 && this.state.FixClicked === true ?
              <Modal isOpen={this.state.FixClicked} className={`${styles.fixModal} fixModal`} id="fixModal" onAfterOpen={this.afterOpenModal}>
                <div ref="errorMSG" className="mdlWrap" >
                  <FixOrder />
                </div>
              </Modal>
              : null}

            <Modal isOpen={this.state.showDialog} className={styles.warningModal} id="trdWarningModal" onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t('error')}</span>
                </div>

                <span onClick={this.closeModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>

                <div className={`${styles.msg} msg commonMsgDir`} id="errorMsgDiv">
                  {this.state.qtyErrorMsg && this.state.qtyErrorMsg != "" ?
                    <p>{i18next.t(this.state.qtyErrorMsg)}</p>
                    : null}

                  {this.state.qtyTypErrMsg && this.state.qtyTypErrMsg != "" ?
                    <p>{i18next.t(this.state.qtyTypErrMsg)}</p>
                    : null}

                  {this.state.statusErrMsg && this.state.statusErrMsg != "" ?
                    <p>{i18next.t(this.state.statusErrMsg)}</p>
                    : null}
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.showtrdFlagModal} className={styles.warningModal} id="mktTrdErrorModal" onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t('error')}</span>
                </div>

                <span onClick={this.closeTrdFlagModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>

                <div className={`${styles.msg} commonMsgDir`}>
                  <p>{i18next.t(!this.state.defaultAccountIsActive ? displayInActiveAccMsg(defaultAcc.D,defaultAcc.C) : 'tradingDisbleByDealerMsg')}</p>
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.cmdtyLimit} className={styles.warningModal} id="cmdtyLimitModal" onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t('warning')}</span>
                </div>

                <span onClick={this.closecmdtyLimitModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>

                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p>{i18next.t('notOpnMoreTrdPanel')}</p>
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.trdProgressFlg} id="trdPnlWrngModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                </div>

                <span onClick={this.closeTrdErrorModal} className={`${styles.closeIcon}`}>{CloseIcon}</span>

                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p>{i18next.t("prevTrdMsg")}</p>
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.netIssueFlg} id="trdPnlConnErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                </div>

                <span onClick={this.closeNetIssueErrorModal} className={`${styles.closeIcon}`}>{CloseIcon}</span>

                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p>{i18next.t("prevTrdErrMsg")}</p>
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.orderSocketClosed} id="trdPnlOrdStsModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                </div>

                <span onClick={this.closeorderSocketClosedModal} className={`${styles.closeIcon}`}>{CloseIcon}</span>

                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p>{i18next.t("orderStatus")}</p>
                </div>
              </div>
            </Modal>

            <div className="headerInner">
              <div className="widgetheader">
                {this.state.key !== 3 ?
                  <span className={`${selectedfont_size} ${this.props.selectedCssColor} widgettitle`}>
                    <TcoDropdown
                      parentDivClassname={`${styles.cmdtyListWrap} cmdtyListWrap`}
                      parentDivId="cmdtyListDiv"
                      dropdownTitle={CmdtyPair}
                      dropdownId="dropdown-size-medium"
                      dropdownData={this.props.TCO}
                      dataItemClick={this.cmdtySelection}
                      dropdownClassname={`${styles.cmdtyDropDown} ${selectedfont_size} cmdtytitleDropDown cmdtyDropDown`}
                      eventKey={cmdtyId}
                      menuClassname={`${selectedfont_size}`}
                    />
                  </span>
                  :
                  <span className={`${selectedfont_size} ${styles.widgettitle} widgettitle`}>
                    <span>{config.Trade_Panel_Header}</span>
                  </span>
                }

                <span onClick={() => this.gridType()} className="vericalDotIcon"></span>
                <div className="resizeLayout">
                  <HoverTable
                    column={5}
                    row={2}
                    width={110}
                    height={46}
                    selectedRow={this.props.height - 1}
                    selectedColumn={this.props.width - 1}
                    onClick={this.onClick}
                    showDimension={true} // show dimension or not
                    onMouseOut={this.onMouseOut}
                    onMouseOver={this.onMouseOver}
                    theme="light"
                    defaultColumn={0}
                    defaultRow={0}
                  />
                </div>
                <span onClick={() => this.closeWidget(keyValue)} id="trdCloseWidget">{CloseIcon}</span>
              </div>
            </div>

            <div className={this.props.height > 1 && this.props.width > 1 ? `${styles.noPadding} ${styles.widgetbody} col-sm-12  ${styles.widgetbodytwo}` :
              this.props.width == 1 && this.props.height == 2 ? `${styles.noPadding} ${styles.widgetbody} col-sm-12  ${styles.widgetbodyone}` : `${styles.noPadding} ${styles.widgetbody} col-sm-12`} onClick={() => this.closeGridType()}>
              <div className={`${styles.trdhead} trdTabBg`}>
                <div className={`${styles.valDate} valDate`}>
                  {this.props.language == 'AR' ?
                    <label>{moment(ValueDate).format(appConstants.rptDateFormat)} : {i18next.t('value')}</label>
                    :
                    <label>{i18next.t('value')}: {moment(ValueDate).format(appConstants.rptDateFormat)}</label>
                  }
                </div>

                <Tabs activeKey={this.state.key} animation={false} id="trade_panel_tabs" onSelect={this.handleSelect} className={`${this.props.selectedCssColor} trdTabName`}>
                  <Tab eventKey={1} title="MKT">
                    <div className={`${styles.part1TabContent} part1TabContent ${this.props.selectedCssColor}`}>
                      {showPrice === "BOTH" && this.props.userDetail.showPriceSpread === true ?
                        <div className={`${styles.rateDiff} rateDiff`}>
                          {parseInt(this.props.status) === 0 && (buttonBidFlag === false && buttonAskFlag === false) && (CmdtyBid > 0 && CmdtyAsk > 0) ? <span> {rateDiff} </span> : <span> {rateDiff} </span>}
                        </div>
                        : null}

                      {this.state.rateToolTip === true && this.state.mount === true ?
                        <ReactTooltip class='toolTip' id={this.props.keyValue + "_bid"} destroyTooltipOnHide={true} delayShow={10} getContent={[() => (<span>{this.state.rateConvRoundOFFBid + " " + selectedMeasureMkt}</span>), 1000]} />
                        : null}

                      {this.state.rateToolTip === true && this.state.mount === true ?
                        <ReactTooltip class='toolTip' id={this.props.keyValue + "_ask"} destroyTooltipOnHide={true} delayShow={10} getContent={[() => (<span>{this.state.rateConvRoundOFFAsk + " " + selectedMeasureMkt}</span>), 1000]} />
                        : null}

                      {singleClickFlag === "1" ? showPrice === "BOTH" ?
                        <div className={this.state.isButtonDisabled === true || buttonBidFlag === true || parseInt(this.props.status) !== 0 || CmdtyBid <= 0 ? variationInBid === 'increment' ? `${styles.increment} ${styles.sell} ${styles.disabled} text-center` : `${styles.decrement} ${styles.sell} ${styles.disabled} text-center` : variationInBid === 'increment' ? `${styles.increment} ${styles.sell} text-center` : `${styles.decrement} ${styles.sell} text-center`} onClick={() => this.orderValidate(QTB, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyBid, ValueDate, 0, baseBidPrice, baseInstId, tempTS)} id="trdMktDiv">

                          {this.state.rateToolTip === true ?
                            <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} data-for={this.props.keyValue + "_bid"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFBid + " " + selectedMeasureMkt} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFBid+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                              {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                <div>
                                  {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>
                                      <p>
                                        {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                            :
                            <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} visible={false} />*/}
                              {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                <div>
                                  {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                          }
                          <div className={`${styles.sellBtn} sellBtn`} id="mktSellbtn" >{i18next.t('SELL')} {D1}</div>
                        </div>
                        : null

                        : showPrice === "BOTH" ?
                          <div className={this.state.isButtonDisabled === true || buttonBidFlag === true || parseInt(this.props.status) !== 0 || CmdtyBid <= 0 ? variationInBid === 'increment' ? `${styles.increment} ${styles.sell} ${styles.disabled} text-center` : `${styles.decrement} ${styles.sell} ${styles.disabled} text-center` : variationInBid === 'increment' ? `${styles.increment} ${styles.sell} text-center` : `${styles.decrement} ${styles.sell} text-center`} onDoubleClick={() => this.orderValidate(QTB, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyBid, ValueDate, 0, baseBidPrice, baseInstId, tempTS)} id="trdMktSellDiv">

                            {this.state.rateToolTip === true ?
                              <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} data-for={this.props.keyValue + "_bid"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFBid + " " + selectedMeasureMkt} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFBid+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                                {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                  <div>
                                    {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                              :
                              <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} visible={false} />*/}
                                {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                  <div>

                                    <p>
                                      {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                            }
                            <div className={`${styles.sellBtn} sellBtn`} id="mktSellbtn">{i18next.t('SELL')} {D1}</div>
                          </div>
                          : null}


                      {singleClickFlag === "1" ? showPrice === "BID" ?
                        <div className={this.state.isButtonDisabled === true || buttonBidFlag === true || parseInt(this.props.status) !== 0 || CmdtyBid <= 0 ? variationInBid === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} ${styles.disabled} text-center` : `${styles.decrement} ${styles.oneSidedPrice} ${styles.disabled} text-center` : variationInBid === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} text-center` : `${styles.decrement} ${styles.oneSidedPrice} text-center`} onClick={() => this.orderValidate(QTB, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyBid, ValueDate, 0, baseBidPrice, baseInstId, tempTS)} id="trdMktDiv">

                          {this.state.rateToolTip === true ?
                            <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} data-for={this.props.keyValue + "_bid"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFBid + " " + selectedMeasureMkt} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFBid+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                              {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                <div>
                                  {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                            :
                            <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} visible={false} />*/}
                              {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                <div>
                                  {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                          }
                          <div className={`${styles.sellBtn} sellBtn`} id="mktSellbtn" >{i18next.t('SELL')} {D1}</div>
                        </div>
                        : null

                        : showPrice === "BID" ?
                          <div className={this.state.isButtonDisabled === true || buttonBidFlag === true || parseInt(this.props.status) !== 0 || CmdtyBid <= 0 ? variationInBid === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} ${styles.disabled} text-center` : `${styles.decrement} ${styles.oneSidedPrice} ${styles.disabled} text-center` : variationInBid === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} text-center` : `${styles.decrement} ${styles.oneSidedPrice} text-center`}
                            onDoubleClick={() => this.orderValidate(QTB, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyBid, ValueDate, 0, baseBidPrice, baseInstId, tempTS)} id="trdMktSellDiv">

                            {this.state.rateToolTip === true ?
                              <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} data-for={this.props.keyValue + "_bid"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFBid + " " + selectedMeasureMkt} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFBid+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                                {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                  <div>
                                    {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                              :
                              <div className={`${styles.buyRate} ${this.props.selectedCssColor} buyBg`} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_bid"} visible={false} />*/}
                                {buttonBidFlag === false && parseInt(this.props.status) === 0 && CmdtyBidArray && CmdtyBid > 0 ?
                                  <div>
                                    {variationInBid ? <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                            }
                            <div className={`${styles.sellBtn} sellBtn`} id="mktSellbtn">{i18next.t('SELL')} {D1}</div>
                          </div>
                          : null}


                      {singleClickFlag === "1" ? showPrice === "BOTH" ?
                        <div onClick={() => this.orderValidate(QTA, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyAsk, ValueDate, 1, baseAskPrice, baseInstId, tempTS)} className={this.state.isButtonDisabled === true || buttonAskFlag === true || parseInt(this.props.status) !== 0 || CmdtyAsk <= 0 ? variationInAsk === 'increment' ? `${styles.increment} ${styles.buy} ${styles.disabled} text-center` : `${styles.decrement} ${styles.buy} ${styles.disabled} text-center` : variationInAsk === 'increment' ? `${styles.increment} ${styles.buy} text-center` : `${styles.decrement} ${styles.buy} text-center`} id="trdmktBuyDiv">

                          {this.state.rateToolTip === true ?
                            <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} data-for={this.props.keyValue + "_ask"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFAsk + " " + selectedMeasureMkt} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFAsk+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                              {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                <div>
                                  {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                            :
                            <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} visible={false} />*/}
                              {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                <div>
                                  {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>
                                      <p>
                                        {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                          }
                          <div className={`${styles.buyBtn} ${this.props.selectedCssColor} buyBtn`} id="mktBuybtn" >{i18next.t('BUY')} {D1}</div>
                        </div>
                        : null

                        : showPrice === "BOTH" ?
                          <div onDoubleClick={() => this.orderValidate(QTA, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyAsk, ValueDate, 1, baseAskPrice, baseInstId, tempTS)} className={this.state.isButtonDisabled === true || buttonAskFlag === true || parseInt(this.props.status) !== 0 || CmdtyAsk <= 0 ? variationInAsk === 'increment' ? `${styles.increment} ${styles.buy} ${styles.disabled} text-center` : `${styles.decrement} ${styles.buy} ${styles.disabled} text-center` : variationInAsk === 'increment' ? `${styles.increment} ${styles.buy} text-center` : `${styles.decrement} ${styles.buy} text-center`} id="trdMktBuy">

                            {this.state.rateToolTip === true ?
                              <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} data-for={this.props.keyValue + "_ask"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFAsk + "" + selectedMeasureMkt} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFAsk+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                                {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                  <div>
                                    {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                              :
                              <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} visible={false} />*/}
                                {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                  <div>
                                    {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                            }
                            <div className={`${styles.buyBtn} ${this.props.selectedCssColor} buyBtn`} id="mktBuybtn">{i18next.t('BUY')} {D1}</div>
                          </div>
                          : null}


                      {singleClickFlag === "1" ? showPrice === "ASK" ?
                        <div onClick={() => this.orderValidate(QTA, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyAsk, ValueDate, 1, baseAskPrice, baseInstId, tempTS)} className={this.state.isButtonDisabled === true || buttonAskFlag === true || parseInt(this.props.status) !== 0 || CmdtyAsk <= 0 ? variationInAsk === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} ${styles.disabled} text-center` : `${styles.decrement} ${styles.oneSidedPrice} ${styles.disabled} text-center` : variationInAsk === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} text-center` : `${styles.decrement} ${styles.oneSidedPrice} text-center`} id="trdmktBuyDiv">

                          {this.state.rateToolTip === true ?
                            <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} data-for={this.props.keyValue + "_ask"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFAsk + " " + selectedMeasureMkt} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFAsk+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                              {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                <div>
                                  {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                            :
                            <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} >
                              {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} visible={false} />*/}
                              {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                <div>
                                  {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                  <p>
                                    {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                      return (
                                        <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                      );
                                    })}
                                  </p>
                                </div>
                                :
                                <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                  {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                    <div>

                                      <p>
                                        {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                          return (
                                            <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                          );
                                        })}
                                      </p>
                                    </div> : <p>- - - -</p>}
                                </div>
                              }
                            </div>
                          }
                          <div className={`${styles.buyBtn} buyBtn`} id="mktBuybtn" >{i18next.t('BUY')} {D1}</div>
                        </div>
                        : null

                        : showPrice === "ASK" ?
                          <div onDoubleClick={() => this.orderValidate(QTA, this.state.COM, selectedQuantityMkt, selectedMeasureMkt, CmdtyAsk, ValueDate, 1, baseAskPrice, baseInstId, tempTS)} className={this.state.isButtonDisabled === true || buttonAskFlag === true || parseInt(this.props.status) !== 0 || CmdtyAsk <= 0 ? variationInAsk === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} ${styles.disabled} text-center` : `${styles.decrement} ${styles.oneSidedPrice} ${styles.disabled} text-center` : variationInAsk === 'increment' ? `${styles.increment} ${styles.oneSidedPrice} text-center` : `${styles.decrement} ${styles.oneSidedPrice} text-center`} id="trdMktBuy">

                            {this.state.rateToolTip === true ?
                              <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} data-for={this.props.keyValue + "_ask"} data-delay-show='10' data-tip={this.state.rateConvRoundOFFAsk + "" + selectedMeasureMkt} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{this.state.rateConvRoundOFFAsk+" "+selectedMeasureMkt}</span>), 1000]} />*/}
                                {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                  <div>
                                    {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                              :
                              <div className={`${styles.sellRate} ${this.props.selectedCssColor} sellBg`} >
                                {/*<ReactTooltip class='toolTip' id={this.props.keyValue+"_ask"} visible={false} />*/}
                                {buttonAskFlag === false && parseInt(this.props.status) === 0 && CmdtyAskArray && CmdtyAsk > 0 ?
                                  <div>
                                    {variationInAsk ? <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}></span></div> : null}
                                    <p>
                                      {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                        return (
                                          <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                  :
                                  <div className={`${styles.priceDownDiv} priceDownDiv`}>
                                    {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                                      <div>

                                        <p>
                                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                                            return (
                                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                                            );
                                          })}
                                        </p>
                                      </div> : <p>- - - -</p>}
                                  </div>
                                }
                              </div>
                            }
                            <div className={`${styles.buyBtn} buyBtn`} id="mktBuybtn">{i18next.t('BUY')} {D1}</div>
                          </div>
                          : null}


                       {this.state.ordConfirmMsg.remark1 !== undefined && this.state.showCnfrmMsg === true ?
                        <div style={this.state.ordConfirmMsg?.rejectedRemark ? { fontSize: '16px' } : {}} className={`${styles.ordConfirmMsg} ordConfirmMsg`}>
                          <span onClick={this.closeOrdConfirmMsg} className={`${styles.closeOrdConfirmMsgIcon} closeOrdConfirmMsgIcon`} id="trdClosePanel">{closeIcon}</span>
                            {i18next.t(this.state.ordConfirmMsg.remark1)}<br />
                            {this.state.ordConfirmMsg?.rejectedRemark ? (
                              <p>
                                {i18next.t(this.state.ordConfirmMsg.remark2)} <br /> {this.state.ordConfirmMsg.rejectedRemark}
                              </p>
                            ) : (
                              <p>{i18next.t(this.state.ordConfirmMsg.remark2)}</p>
                            )}
                        </div>
                        : null}

                      {/*parseInt(this.props.status) !== 0 ?
                        <div className={`${styles.noRatesMsgDiv} noRatesMsgDiv`} style={noRatesMsgDiv}><p>{i18next.t('noRatesAvailMsg')}</p></div>
                      : null*/}
                    </div>


                    <div className={`${styles.part2TabContent} part2TabContent`}>
                      <div>
                        <div className={`${styles.rightPart} rightPart ${this.props.language}`}>
                          <div className={`${styles.col3} col3`} style={this.props.selectedLang.col3}>
                            <p className="cmdtyType">{D1}</p>
                          </div>

                          <div className={this.state.COM === 2 && !this.state.isCustInst ? `${styles.col5} trade_MKT_tabs` : `${styles.col8} trade_MKT_tabs`} id="trade_MKT_tabs" style={this.props.selectedLang.col5}>
                            <ButtonToolbar>
                              <DropdownButton id="dropdown-size-medium" className={  (`dropdownBtn `)+(this.state.COM === 2 && !this.state.isCustInst ? "trdDropDown" : `${styles.mktQuantityDropdown} trdDropDown`)}>
                                {DFMKT.map((qntity) => {
                                  return (
                                    <MenuItem onClick={this.quantitySelectionMkt} id="trdSelectMkt" className="dropDownList">{qntity}</MenuItem>
                                  );
                                })}
                              </DropdownButton>
                            </ButtonToolbar>
                            <input type="text" autoComplete="off" className={`${styles.dropdownInput} trdDropdownInput`} onBlur={this.onBlurMKT} value={selectedQuantityMkt} onChange={this.quantityTypedMkt} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")} />
                          </div>

                          {this.state.COM === 2 && !this.state.isCustInst ?
                            <div className={`${styles.col4} trade_MKT_tabs`} style={this.props.selectedLang.col4} id="mktUnitMeasure">
                              <ButtonToolbar>
                                <DropdownButton title={selectedMeasureMkt} id="dropdown-size-medium" className={stkCodeClass === true ? `${styles.mktQuantityType} trdDropDown trdMeasureDrpDown singleOptn`:`${styles.mktQuantityType} trdDropDown trdMeasureDrpDown dropdownBtn`} >
                                  {MEASURE && MEASURE.map((unitMeasure) => {
                                    return (
                                      <MenuItem onClick={this.selectMeasureMkt} id="trdMeasureMkt" className="dropDownList dropDownLst" >{unitMeasure}</MenuItem>
                                    );
                                  })}
                                </DropdownButton>
                              </ButtonToolbar>
                            </div>
                            : null}
                        </div>
                        <div className={`${styles.comments_wrap} commentDiv`}>
                          <div className={`${styles.comments}`}>
                            <textarea type="text" ref="commentMkt" placeholder={i18next.t('comments')} style={comments} onBlur={this.onBlurMKTRmk} className="form-control trdComments" id="mktCommentText"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  {this.props.userDetail.enableCustomerOrder ? <Tab eventKey={2} title="LMT"></Tab> : null}
                  {this.props.userDetail.enableFXOrd ? <Tab eventKey={3} title="FIX"></Tab> : null}
                </Tabs>
              </div>
            </div>
          </div>
          : null}
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    ACD: state.auth.ACD,
    userDetail: state.auth.userDetail,
    layout: state.dashboardRoot.dashboardReducer.layout,
    deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
    trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
    TCO: state.dashboardRoot.instrumentListReducer.TCO,
    status: state.dashboardRoot.instrumentListReducer.status,
    trdingFlag: state.dashboardRoot.tradepanelReducer.trdingFlag,
    ordcnfrmsg: state.dashboardRoot.activityReducer.ordcnfrmsg,
    webSocketFlag: state.dashboardRoot.instrumentListReducer.webSocketFlag,
    socketData: state.dashboardRoot.instrumentListReducer.socketData,
    socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
    check: state.dashboardRoot.instrumentListReducer.check,
    closeLmtFlag: state.dashboardRoot.dashboardReducer.closeLmtFlag,
    selectedCssColorTheme: state.dashboardRoot.commonReducer.selectedCssColorTheme,
    lmtKeyValue: state.dashboardRoot.dashboardReducer.lmtKeyValue,
    tradeWidgetCnt: state.dashboardRoot.dashboardReducer.tradeWidgetCnt,
    trdCTID: state.dashboardRoot.activityReducer.trdCTID,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    stkWiseMarkup: state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
    DCO: state.dashboardRoot.instrumentListReducer.DCO,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    stkWiseMarkupRandomNo: state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
    orderStatus: state.dashboardRoot.tradepanelReducer.orderStatus,
    closeFixFlag: state.dashboardRoot.dashboardReducer.closeFixFlag,
    fixKeyValue: state.dashboardRoot.dashboardReducer.fixKeyValue,
    custInstStkData: state.dashboardRoot.instrumentListReducer.custInstStkData,
    instData: state.dashboardRoot.instrumentListReducer.instData,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    handleSellBuyOrder: tradepanelActions.handleSellBuyOrder,
    setTradingstatus: tradepanelActions.setTradingstatus,
    closeWebSocketTrade: tradepanelActions.closeWebSocketTrade,
    validateOrder: commonActions.validateOrder,
    deleteWidget: dashboardActions.deleteWidget,
    changeCmdyPair: dashboardActions.changeCmdyPair,
    closedLmtModal: dashboardActions.closedLmtModal,
    resizeTradePanel: dashboardActions.resizeTradePanel,
    tradeCnt: dashboardActions.tradeCnt,
    closedFixModal: dashboardActions.closedFixModal,
    subscribeTier: instrumentListActions.subscribeTier,
    setTrdCTID: activityActions.setTrdCTID,
    logout: authActions.logout,
    layoutChanged:dashboardActions.layoutChanged,
    closeOrdConfirmMsg:activityActions.closeOrdConfirmMsg,
    closeSocketTrade: tradepanelActions.closeSocketTrade,
    closeSocketData: instrumentListActions.closeSocketData,
    logFileCreation: commonActions.logFileCreation,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TradePanelComponent);
